import { useEffect, useState } from 'react';
import { supabase } from './App';
import { map as m,compose as C, prop as p, indexBy} from 'ramda';
import './kava.css';
import { hashCodeFromSeat } from './helpers';

const date_and_id = ({date,id}) => {
    const d = new Date(date);
    const formatted = `${d.getDate()}-${d.getMonth() + 1}-${d.getFullYear().toString().slice(-2)}`

    return {date:formatted, code: `${hashCodeFromSeat(formatted)}-${id}`};
};

export const Kava = () => {
    const [events, setEvents] = useState([]);
    const [mockAmounts, setMockAmounts] = useState({});
    const fetchEvents = async() => {
        const { data, error } = await supabase.from("events").select("*");
        if (error) {
            console.error("Error fetching events:", error);
        } else {
            const formatted = m(date_and_id,data) 
            setEvents(formatted);
            setMockAmounts(C(m(() => 0),indexBy(p("code")))(formatted));
        }
    };
    useEffect(() => {
        fetchEvents();
    }, []);
    return <>
        <div id="header">
            <h1>ANDME</h1>
            <img src="/favicon.svg" id="logo" alt="Logo"/>
            <h1>TEATER</h1>
        </div>
        <div id="events">
            {m(({code, date}) => <div key={code}>
                <h2>Salme {date}</h2>
                <div>                    
                    <a className="button-link" href={`/pult/${code}`}>pult</a>
                    <a className="button-link" href={`/lava/${code}`}>lava</a>
                    <span className="button-link with-nr">
                        <button onClick={() => setMockAmounts({...mockAmounts,[code]:Math.max(0,mockAmounts[code]-50)})}>-</button>
                        <a href={`/vasta/${code}?from=${mockAmounts[code]}&to=${mockAmounts[code]+50}`}>{mockAmounts[code]}-{mockAmounts[code]+50}</a>
                        <button onClick={() => setMockAmounts({...mockAmounts,[code]:Math.min(600,mockAmounts[code]+50)})}>+</button>
                    </span>
                </div>
            </div>,events)}
        </div>
    </>
}